<template>
  <div class="app-container" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="月度核算" name="one" style="">
        <monthHeSuan v-if="activeName=='one'" ref="monthHeSuan" @switchToDetails="handleSwitchToDetails"></monthHeSuan>
      </el-tab-pane>
      <el-tab-pane label="核算明细" name="two">
        <hesuanmingxi v-if="activeName=='two'" ref="hesuanmingxi" :detailId="detailId" :yearMonth="yearMonth"></hesuanmingxi>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import monthHeSuan from '@/views/newTMS/costExpense/danrenhesuan/monthHeSuan.vue'
import hesuanmingxi from '@/views/newTMS/costExpense/danrenhesuan/hesuanmingxi.vue'
export default {
  components: {
    monthHeSuan, hesuanmingxi
  },
  data () {
    return {
      activeName: 'one',
      detailId: null,
      yearMonth: ''
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  },
  methods: {
    handleSwitchToDetails (params) { // 新增
      this.detailId = params && params.id ? params.id : null
      this.yearMonth = params && params.yearMonth ? params.yearMonth : ''
      this.activeName = 'two'
    },
    handleClick (tab) { // 新增
      if (tab.name === 'two' && !this.detailId && this.$refs.hesuanmingxi) {
        this.$refs.hesuanmingxi.loadDefaultData()
      }
      if (tab.name === 'one') {
        this.detailId = null
        this.yearMonth = ''
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
